namespace TabAurous.Retail {
    export interface POSSalesReportForm {
        TransDate: Serenity.DateEditor;
        VoucherNo: Serenity.StringEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        RefVoucherId: Serenity.IntegerEditor;
        DeppartmentId: Serenity.IntegerEditor;
        PartyId: Serenity.IntegerEditor;
        POSCustomerId: Serenity.IntegerEditor;
        TermsId: Serenity.IntegerEditor;
        CurrencyId: Serenity.IntegerEditor;
        ExchRate: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        Roundoff: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
        Discount: Serenity.DecimalEditor;
        AdditionalCharges: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        Remark: Serenity.StringEditor;
        CompanyId: Serenity.LookupEditor;
        BillNo: Serenity.StringEditor;
        BillDate: Serenity.DateEditor;
        ChallanNo: Serenity.StringEditor;
        ChallanDate: Serenity.DateEditor;
        EmployeeId: Serenity.IntegerEditor;
        AddressId: Serenity.IntegerEditor;
        ShipmentId: Serenity.IntegerEditor;
        ShipAddressId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        UserId: Serenity.IntegerEditor;
    }

    export class POSSalesReportForm extends Serenity.PrefixedContext {
        static formKey = 'Retail.POSSalesReport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!POSSalesReportForm.init)  {
                POSSalesReportForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.LookupEditor;

                Q.initFormType(POSSalesReportForm, [
                    'TransDate', w0,
                    'VoucherNo', w1,
                    'VoucherTypeId', w2,
                    'RefVoucherId', w2,
                    'DeppartmentId', w2,
                    'PartyId', w2,
                    'POSCustomerId', w2,
                    'TermsId', w2,
                    'CurrencyId', w2,
                    'ExchRate', w3,
                    'NetAmount', w3,
                    'Roundoff', w3,
                    'TaxAmount', w3,
                    'Discount', w3,
                    'AdditionalCharges', w3,
                    'GrossAmount', w3,
                    'Pieces', w2,
                    'Weight', w3,
                    'NetWeight', w3,
                    'Remark', w1,
                    'CompanyId', w4,
                    'BillNo', w1,
                    'BillDate', w0,
                    'ChallanNo', w1,
                    'ChallanDate', w0,
                    'EmployeeId', w2,
                    'AddressId', w2,
                    'ShipmentId', w2,
                    'ShipAddressId', w2,
                    'FinancialYearId', w2,
                    'UserId', w2
                ]);
            }
        }
    }
}
